import React from 'react';
import { withRouter } from 'react-router';
import { Overlay, Label } from 'react-bootstrap';

import { parseQs, stringifyQs } from 'helpers/http';

import SidebarAwarePopover from 'components/SidebarAwarePopover';

class ListFilterBody extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };

    this.headerRef = React.createRef();
  }

  show = e => {
    e.preventDefault();
    this.setState({ show: true });
  };

  close = () => {
    this.setState({ show: false });
  };

  resetFilter = e => {
    e.preventDefault();

    const { location, history, paramNames } = this.props;
    const query = parseQs(location.search);

    for (let i = 0; i < paramNames.length; i++) {
      delete query[paramNames[i]];
    }

    history.push({
      pathname: location.pathname,
      search: stringifyQs(query),
    });

    this.setState({ show: false });
  };

  render() {
    const { title, body, isActive, paramNames } = this.props;
    const { show } = this.state;

    return (
      <>
        <a
          href="#showFilterOptions"
          className={`list-filter ${show ? 'active' : ''}`}
          onClick={this.show}
          ref={this.headerRef}
        >
          {title}
          {isActive && (
            <Label className="m-l-5 label-primary-bg">
              <i className="fal fa-check" />
            </Label>
          )}
          <i className="fal fa-chevron-down m-l-10" />
        </a>

        <Overlay show={show} target={this.headerRef.current} placement="bottom" rootClose onHide={this.close}>
          <SidebarAwarePopover className="filter-popover">
            {isActive && !!paramNames && (
              <div className="padding-10 m-b-5 b-b b-grey text-right">
                <a href="#resetFilter" className="reset-filter" onClick={this.resetFilter}>
                  Reset
                </a>
              </div>
            )}
            {body}
          </SidebarAwarePopover>
        </Overlay>
      </>
    );
  }
}
ListFilterBody.defaultProps = {};

export default withRouter(ListFilterBody);
